import React from 'react';
import { userInfo } from '@apollo-internal/cache';
import { useReactiveVar } from '@apollo/client';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';
import PrivilegeNames from '../../../../../constants/privilegeNames';
import CommentaryInput from './CommentaryInput';

/**
 * @typedef {object} CommentarySectionProps
 * @property {string} [commentary]
 * @property {boolean} [loading]
 * @property {(commentary: string) => void} [handleSaveCommentary]
 */

/**
 * @param {CommentarySectionProps} props
 */
const CommentarySection = props => {
  const { commentary, handleSaveCommentary, loading = false } = props;

  const currentUserInfo = useReactiveVar(userInfo);

  const canEditCommentary = currentUserInfo.Privileges.includes(
    PrivilegeNames.OrganizationReports_ExecutiveSummary_EditCommentary
  );

  return (
    <section className='commentary-section'>
      <h4>Commentary</h4>
      <div className='commentary-section__content'>
        <SkeletonWrapper show={loading} inheritParentSize>
          {canEditCommentary ? (
            <CommentaryInput commentary={commentary} handleSaveCommentary={handleSaveCommentary} />
          ) : (
            <p>{commentary}</p>
          )}
        </SkeletonWrapper>
      </div>
    </section>
  );
};

export default CommentarySection;
